import { AddRounded, ExpandMore } from "@mui/icons-material";
import { AccordionDetails, Grid, IconButton } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { SyntheticEvent, useState } from "react";
import { useFieldArray, useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { cbContactPersonToDeleteArrayState, isGlobalEditModeState } from "../state/customerbaseState";
import { CBCreationOfProps, DELETE_SYMBOL, IFormValues } from "../types";
import CustomerBaseContactPersonDetails from "./CustomerBaseContactPersonDetails";
import UpdateBtnsAccordion from "./UpdateBtnsAccordion";
import CBFormTextFieldController from "./formController/CBFormTextFieldController";
import CBAccordionTitle from "./CBAccordionTitle";

const CustomerBaseCorporateInfoDetails = ({creationOf} : CBCreationOfProps) => {

    const { t } = useTranslation('customerbase');
    const isCreationMode = !!creationOf;
    const formContext  = useFormContext<IFormValues>();
    const [isExpanded, setIsExpanded] = useState(isCreationMode);
    const isGlobalEditMode = useRecoilValue(isGlobalEditModeState);
    const editing = isGlobalEditMode;
    const contactPersonsFieldArray = useFieldArray<IFormValues, 'cbCorporateInfo.contactPersons'>({
        name: "cbCorporateInfo.contactPersons",
        control: formContext.control
    });
    
    const cbContactPersonToDeleteArray = useRecoilValue(cbContactPersonToDeleteArrayState);
    const setCbContactPersonToDeleteArray = useSetRecoilState(cbContactPersonToDeleteArrayState);    

    const appendNewContactPerson = () => {
        contactPersonsFieldArray.append({
            //cbCustomerId: "",
            //bpCode: "",
            name: "",
            surname: "",
            address: "",
            houseNumber: "",
            country: "",
            region: "",
            city: "",
            postalCode: "",
            phoneNumber: "",
            mobile: "",
            email: "",
            delete: ""
        });
    }

    const onAdd = (event: SyntheticEvent) => {
        event.stopPropagation();
        appendNewContactPerson();
    }

    const onRemove = (event: SyntheticEvent, index: number) => {
        event.stopPropagation();

        if(!!formContext.getValues(`cbCorporateInfo.contactPersons.${index}.id`)) {
            const toDelete = formContext.getValues(`cbCorporateInfo.contactPersons.${index}`);
            setCbContactPersonToDeleteArray([...cbContactPersonToDeleteArray, {
                id: toDelete.id,
                bpCode: toDelete.bpCode,
                name: toDelete.name,
                surname: toDelete.surname,
                address: toDelete.address,
                houseNumber: toDelete.houseNumber,
                country: toDelete.country,
                region: toDelete.region,
                city: toDelete.city,
                postalCode: toDelete.postalCode,
                phoneNumber: toDelete.phoneNumber,
                mobile: toDelete.mobile,
                email: toDelete.email,
                delete: DELETE_SYMBOL
            }]);
        }

        contactPersonsFieldArray.remove(index);

    }

    return (
        <Accordion defaultExpanded={isCreationMode} expanded={isExpanded} onChange={(_e, expanded) => {
            setIsExpanded(expanded);
        }}>
            <AccordionSummary expandIcon={ <ExpandMore />}>
                {isCreationMode ?
                    <Grid container alignItems="center" width={"98%"}>
                        <Grid item md={6} xs={6}>
                            <CBAccordionTitle
                                section="cbCorporateInfo"
                                label={t("tabs.accordionsLabels.cbCorporateInfoDetails")}
                            />
                        </Grid>
                        <Grid item container justifyContent={"flex-end"} md={6} xs={6}>
                            <Grid item>
                                <IconButton
                                    color={"accent"}
                                    disabled={!isExpanded}
                                    onClick={onAdd}
                                >
                                    <AddRounded/>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                    :
                    <UpdateBtnsAccordion
                        section="cbCorporateInfo"
                        label={t("tabs.accordionsLabels.cbCorporateInfoDetails")}
                        editing={editing}
                        isExpanded={isExpanded}
                        showAdd={editing}
                        onAdd={onAdd}
                    />
                }
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    {/*<Grid item md={6} xs={12}>
                        <FormController
                            formName="cbCorporateInfo.salesArea"
                            label="salesArea"
                            options={sapEnum.salesAreas || []}
                            showSelect={isCreationMode || editing}                       
                        />
                    </Grid>*/}
                    {/*<Grid item md={6} xs={12}>
                        <CBFormTextFieldController 
                            formName={"cbCorporateInfo.fleet"}
                            label={"fleet"}
                            readOnly={isCreationMode ? false : !editing}
                        /> 
                    </Grid>*/}
                    {/*<Grid item md={6} xs={12}>
                        <FormController
                            formName="cbCorporateInfo.class"
                            label="class"
                            options={sapEnum.classes || []}
                            showSelect={isCreationMode || editing}                       
                        />
                        </Grid>*/}
                    {/*<Grid item md={6} xs={12}>
                        <FormController
                            formName="cbCorporateInfo.sizingClass"
                            label="sizingClass"
                            options={sapEnum.sizingClasses || []}
                            showSelect={isCreationMode || editing}                       
                        />
                    </Grid>*/}
                    <Grid item md={6} xs={12}>
                        <CBFormTextFieldController 
                            formName={"cbCorporateInfo.maxRentalNum"}
                            idField={"max-rental-number"}
                            label={"maxRentalNum"}
                            readOnly={isCreationMode ? false : !editing}
                            type="number"
                        /> 
                    </Grid>
                    <Grid item container rowSpacing={1}>
                        {
                            contactPersonsFieldArray.fields.map((cp, index) => (
                                <Grid item md={12} xs={12} key={`cp-detail-${cp.id}`}>
                                    <CustomerBaseContactPersonDetails
                                        creationOf={creationOf}
                                        defaultExpanded={ index == 0 }
                                        isExpanded={isExpanded}
                                        index={index}
                                        editing={editing}
                                        isNew={isCreationMode}
                                        onRemove={onRemove}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default CustomerBaseCorporateInfoDetails;